import React from "react";

// Ventrix isometric-cube mark, recreated as an inline SVG so it is crisp at any
// size, self-contained (no asset request / CSP-safe), and recolorable. Colors
// match the brand logo: orange top, dark-teal left face, grey-teal right face.
const TOP = "#F0A63A";    // orange
const LEFT = "#123A3E";   // dark teal
const RIGHT = "#5F8385";  // grey-teal

export default function BrandMark({ size = 32, className = "", title = "Ventrix" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      style={{ display: "block" }}
    >
      {/* top face (rhombus) */}
      <polygon points="50,6 90,29 50,52 10,29" fill={TOP} />
      {/* left face */}
      <polygon points="10,29 50,52 50,94 10,71" fill={LEFT} />
      {/* right face */}
      <polygon points="50,52 90,29 90,71 50,94" fill={RIGHT} />
    </svg>
  );
}
